import React from 'react';
import getIcons from '../../functions/getIcons/getIcons';
import * as actions from '../../redux/actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const ThemeNineFooter = (props) => {
console.log("props in footer",props)
  const operator = props.operator
  return operator ? (
    <div>
      <div className="themes-theme-nine-footer">
        <div className="footer-wrapper new-container">
          <div className="left footer-item">
            <div className=" ">
              <a href="/">
                <img src={operator && operator.footer_logo} alt="" style={{width: operator && operator.footer_logo_width}}/>
              </a>
            </div>
            
            {/* <div className="spl-services">
              <span><a href='/services-special'>Servicios especiales</a></span>
              <span><a href='https://www.paketcargo.cl/web/' target='_blank'>Servicios de encomiendas</a></span>
            </div>
            <div className="email-info">
              <span className="bold-text">Postulaciones</span>
              <span>rrhh@busesahumada.cl</span>
            </div> */}
          </div>

          <div className="center footer-item">
          <div className="heading-and-line">
              <span className="title">{operator && operator.name && operator.name}</span>
              <span className="line"></span>
            </div>

           { operator && operator.operator_name == "busesahumada" && <div className="contact-info ">

              <div className="image">
                <img src={getIcons('contactHeadphone')} />
              </div>
              <div>
                <span className="bold-text">Call center:</span>
                <span> {operator && operator.phone_number && operator.phone_number}</span>
              </div>
            </div>}
            <div className="contact-info">
              <div className="image">
                <img src={getIcons('contactMail')} />
              </div>
              <div>
                <span className="bold-text">Escríbenos:</span>
                <span> {operator && operator.email && operator.email}</span>
              </div>
            </div>
            <div className="contact-info">
              <div className="image">
                <img src={getIcons('contactLocation')} />
              </div>
              <div>
                <span className="bold-text">Casa matriz:</span>
                <span> {operator && operator.address && operator.address}</span>
              </div>
            </div>
          </div>

          { operator && operator.operator_name == "busesahumada" && <div className="right footer-item">
            <div className="avalibility">
              <div className="bold-text">Horarios de atención: </div>
              <div className="timing">Lunes a sábado: 06:00 a 20:30 hrs.</div>
            </div>
          </div>}

        </div>
      </div>
      <div className="copy-right-section">
        <span>
        {operator && operator.name && operator.name} {new Date().getFullYear()} - Todos los derechos reservados ©  |  Powered by <a href='https://kupos.cl' target='_blank'>kupos.cl</a>
        </span>
      </div>
    </div>
  ) : null;
};

// export default ThemeNineFooter;

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeNineFooter);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeNine/common/ThemeNineFooter.js